import Backbone from 'backbone'
import $ from 'jquery'
import icon from 'scoreboard/components/icon'
import { SHAPE_TEXT_BOLD, SHAPE_TEXT_ITALIC, SHAPE_TEXT_UNDERLINE } from '../shape-widget-properties'
import { isV6 } from 'scoreboard/components/version'

const SHAPE_TEXT_STYLE_OPTIONS = [
	{ property: SHAPE_TEXT_BOLD, icon: 'bold' },
	{ property: SHAPE_TEXT_ITALIC, icon: 'italics' },
	{ property: SHAPE_TEXT_UNDERLINE, icon: 'underline' }
]

/**
 * Config view for setting Bold/Italic/Underline on a shape widget's text
 */
const ShapeTextStyleOption = Backbone.View.extend({
	className: 'config-multiple-choice',
	tagName: 'ul',

	events: {
		'click li.font-style': 'onClickOption'
	},

	initialize: function (options = {}) {
		this.options = options
	},

	render: function () {
		var props = this.model.properties.toJSON()

		var choices = SHAPE_TEXT_STYLE_OPTIONS.map(choice => {
			let selected = props[choice.property] ? 'selected' : ''
			let listClasses = 'font-style '
			if (isV6()) {
				listClasses += ' button-boolean'
			}
			return `<li class="${listClasses} ${selected}"` +
				` data-style-property="${choice.property}">` +
				`${icon(choice.icon)}</li>`
		})

		this.$el.append(choices)

		return this
	},

	onClickOption (e) {
		let prop = $(e.currentTarget).data('style-property')
		let newValue = !this.model.properties.get(prop)

		$(e.currentTarget).toggleClass('selected', newValue)

		this.options.widgetUpdater.setProperty(prop, newValue)
	}
})

export default ShapeTextStyleOption

ShapeTextStyleOption.__filename__ = 'dashboards/widgets/shape/config/shape-text-style-option.js'
